
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const discountApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listDiscounts: builder.query ({
      query: (params) => `v2/discount/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Discount"]
    }),
    getDiscount: builder.query ({
      query: (discount_id) => `v2/discount/${discount_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Discount"]
    }),
    getDiscountOrders: builder.query ({
      query: (discount_id) => `v2/order/?discount=${discount_id}`,
      keepUnusedDataFor: 1,
      providesTags: ["Order"]
    }),
    updateDiscount: builder.mutation ({
      query: ({discount_id, data}) => ({
        url: `v2/discount/${discount_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Discount"]
    }),
    deleteDiscount: builder.mutation ({
      query: (discount_id) => ({
        url: `v2/discount/${discount_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Discount"]
    }),
    createDiscount: builder.mutation ({
      query: (data) => ({
        url: `v2/discount/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Discount"]
    }),
  })
})


export const {
  useListDiscountsQuery,
  useLazyListDiscountsQuery,
  useGetDiscountQuery,
  useLazyGetDiscountQuery,
  useGetDiscountOrdersQuery,
  useUpdateDiscountMutation,
  useDeleteDiscountMutation,
  useCreateDiscountMutation
} = discountApi
